/* global document, Office, localStorage, window, process, URLSearchParams, console, */

import { initSessionManager, setToken, deleteToken, setUsed } from "../common/sessionManager";

let emailType = "";
(async () => {
  const info = await officeReady();
  if (info.host === Office.HostType.Outlook) {
    setUsed();
    const selectedItems = await getSelectedItems();
    emailType = selectedItems[0].itemMode;
    const token = await localStorage.getItem("token");
    const tokenDate = parseInt(localStorage.getItem("tokenDate"), 10);
    const now = Date.now();
    const tokenExpire = 86400 * 1000;
    await setExtensionUsed(false);
    if (token && now - tokenDate < tokenExpire) {
      await redirectionPage();
    } else {
      deleteToken();
    }
    document.getElementById("loginClick").onclick = async function () {
      await openLogin();
    };
    const params = new URLSearchParams(window.location.search);
    if (params.get("action") === "connexion") {
      await openLogin();
    }
  }
})();
function officeReady() {
  return new Promise((resolve) => {
    Office.onReady((info) => {
      resolve(info);
    });
  });
}

function getSelectedItems() {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.getSelectedItemsAsync((asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value);
      } else {
        reject(asyncResult.error);
      }
    });
  });
}

async function openLogin() {
  await Office.context.ui.displayDialogAsync(
    `${process.env.API_URL}/login`,
    { height: 90, width: 100 },
    function (asyncResult) {
      if (asyncResult.status === Office.AsyncResultStatus.Failed) {
        console.log(process.env.API_URL);
        console.log(asyncResult.error.code + ": " + asyncResult.error.message);
      } else {
        var dialog = asyncResult.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg) => {
          dialog.close();
          await processMessage(arg);
        });
      }
    }
  );
}

async function processMessage(arg) {
  const data = JSON.parse(arg.message);
  initSessionManager();
  setToken(data.token, data.mail_gestionnaire);
  await redirectionPage();
}

async function redirectionPage() {
  const itemMode = Office.context.mailbox.item.itemClass;
  if (emailType === "Read") {
    if (itemMode) {
      await setExtensionUsed(false);
      window.location.href = "acceuil.html";
    } else {
      await setExtensionUsed(true);
      window.location.href = "compose.html";
    }
  } else if (emailType === "Compose") {
    await setExtensionUsed(true);
    window.location.href = "compose.html";
  }
}

function setExtensionUsed(value = true) {
  return new Promise((resolve, reject) => {
    try {
      Office.context.roamingSettings.set("extensionUsed", value);
      Office.context.roamingSettings.saveAsync(function (asyncResult) {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          resolve();
        } else {
          reject(asyncResult.error);
        }
      });
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
